$.fn.slidingPanel = function () {
    $(this).each(function () {
        var $body = $("#main-content");
        var width_percent_one_third = "33.333%";
        var width_percent_two_third = "66.666%";
        var $this = $(this);
        var $wrapper = $body.find(".js-sliding-panel-wrapper");
        var $content = $body.find(".js-sliding-panel-content");
        var $sibling = $body.find(".js-sliding-panel-sibling");

        // Find or derive the target panel's ID (e.g. 'filters-slider-content' or dynamic ID from settings)
        var targetId = $content.attr('id') || 'filters-slider-content';

        var $hook = $('<a href="#" aria-expanded="false" aria-controls="' + targetId + '">Show filters</a>');

        var $header = $body.find(".js-sliding-panel-header");

        // ------------------------------
        // Event listeners
        // ------------------------------
        function isInCollectionRequestPage() {
            return $("#collection-request-page").length > 0;
        }

        function isInTestCollectionRequestPage() {
            return $("#test-collection-request-page").length > 0;
        }

        function toggleAriaAttributes(expanding) {
            //$header.removeAttr("aria-expanded aria-controls"); // Clean up header if previously rendered by template
            $hook.attr("aria-expanded", expanding ? "true" : "false");
            $content.attr("aria-hidden", expanding ? "false" : "true");
        }

        $this.click(function (event) {
            event.preventDefault();
            if (
                isInTestCollectionRequestPage() &&
                window.location.href.indexOf("?") == -1
            ) {
                if ($this.data("is-expanded")) {
                    $sibling.animate({
                        width: width_percent_two_third,
                    }, function () {
                        $sibling.css("width", "");
                    });

                    $content.animate(
                        {
                            marginLeft: "0%",
                        },
                        function () {
                            $wrapper.find(".js-sliding-panel-content").show();
                            $wrapper.addClass("js-sliding-panel-wrapper-expanded");
                        },
                    );

                    toggleAriaAttributes(false);
                    $this.data("is-expanded", false);

                    $hook.text("Hide filters");
                } else {
                    $content.animate({
                        marginLeft: `-${width_percent_one_third}`,
                    });

                    $sibling.animate({
                        width: "100%",
                    });
                    $wrapper.find(".js-sliding-panel-content").hide();

                    $wrapper.removeClass("js-sliding-panel-wrapper-expanded");

                    toggleAriaAttributes(true);
                    $this.data("is-expanded", true);

                    $hook.text("Show filters");
                }
            } else {
                if ($this.data("is-expanded")) {
                    // panel is currently expanded, let's hide it.
                    $content.css({position: 'absolute', left: 0, width: `calc(${width_percent_one_third} - 30px)`});
                    $content.animate({
                        left: `-${width_percent_one_third}`,
                    }, undefined, undefined, function () {
                        if (!$this.data("is-expanded")) {
                            $content.hide();
                        }
                    });
                    $sibling.css({marginLeft: width_percent_one_third});
                    $sibling.animate({
                        width: "100%",
                        marginLeft: '0'
                    });

                    $wrapper.removeClass("js-sliding-panel-wrapper-expanded");

                    toggleAriaAttributes(false);
                    $this.data("is-expanded", false);

                    $hook.text("Show filters");
                } else {
                    // panel is currently hidden, let's expand it.
                    $content.css({
                        position: 'absolute',
                        left: `-${width_percent_one_third}`,
                        marginLeft: '0',
                        width: `calc(${width_percent_one_third} - 30px)`
                    });
                    $content.show();
                    $content.animate({
                        left: "0",
                    });
                    $sibling.animate({
                        width: width_percent_two_third,
                        marginLeft: width_percent_one_third
                    }, undefined, undefined, function () {
                        if ($this.data("is-expanded")) {
                            $content.css({position: 'initial', left: '0', width: '100%'});
                            $wrapper.addClass("js-sliding-panel-wrapper-expanded");
                            $sibling.css({marginLeft: '0', width: ''});
                        }
                    });

                    toggleAriaAttributes(true);
                    $this.data("is-expanded", true);

                    $hook.text("Hide filters");
                }
            }
        });

        // ------------------------------
        // Initialisation
        // ------------------------------

        if ($this.data("is-expanded")) {
            $sibling.css("width", width_percent_two_third);
            $content.css({
                marginLeft: "0%",
            });
            $wrapper.find(".js-sliding-panel-content").show();
            $wrapper.addClass("js-sliding-panel-wrapper-expanded");

            toggleAriaAttributes(true);
            $this.data("is-expanded", true);
        } else {
            $sibling.css("width", "100%");
            $content.css({
                marginLeft: "-" + width_percent_one_third,
            }); // Negative 'marginLeft'
            $wrapper.find(".js-sliding-panel-content").hide();

            toggleAriaAttributes(false);
            $this.data("is-expanded", false);
        }

        if (
            isInTestCollectionRequestPage() &&
            window.location.href.indexOf("?") == -1
        ) {
            $wrapper.find(".js-sliding-panel-content").hide();
            $wrapper.removeClass("js-sliding-panel-wrapper-expanded");
            $sibling.css("width", "100%");
            $content.css({
                marginLeft: "-" + width_percent_one_third,
            }); // Negative 'marginLeft'
            $this.data("is-expanded", true);
        }

        if ($this.parents(".data-grid-delta-2").length) {
            $this.text("").append($('<i class="fa fa-search"></i>')).append($hook);
        } else {
            $this.text("").append($hook);
        }
    });
};
